import { forwardRef } from 'react';
import { SvgIcon } from '@material-ui/core';

export const IconFolderFilled = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 16 16"
    data-fill-none
  >
    <path
      d="M15.1818 5.27273C15.1818 4.9834 15.0669 4.70592 14.8623 4.50134C14.6577 4.29675 14.3802 4.18182 14.0909 4.18182H7L5.69091 2.43636C5.58929 2.30088 5.45753 2.19091 5.30605 2.11517C5.15457 2.03943 4.98754 2 4.81818 2H2.09091C1.80158 2 1.52411 2.11493 1.31952 2.31952C1.11493 2.5241 1 2.80158 1 3.09091V12.9091C1 13.1984 1.11493 13.4759 1.31952 13.6805C1.52411 13.8851 1.80158 14 2.09091 14H14.0909C14.3802 14 14.6577 13.8851 14.8623 13.6805C15.0669 13.4759 15.1818 13.1984 15.1818 12.9091V5.27273Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
